"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_utils_1 = require("@8x8/oxygen-utils");
const oxygen_config_1 = require("@8x8/oxygen-config");
const themeName_1 = require("../constants/themeName");
const ProgressBar_1 = require("../styled/ProgressBar");
const types_1 = require("../types");
const ProgressBar = ({ theme, value, text, ...rest }) => {
    const uniqueId = (0, oxygen_utils_1.useId)();
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(ProgressBar_1.ProgressBarContainer, { ...rest, ...(text && { 'aria-labelledby': uniqueId }) },
            react_1.default.createElement(ProgressBar_1.Bar, { value: value, max: 100 }),
            text && react_1.default.createElement(ProgressBar_1.ProgressBarText, { id: uniqueId }, text))));
};
ProgressBar.propTypes = {
    /**
     * ProgressBar theme
     */
    theme: prop_types_1.default.object,
    /**
     * Percentage of completed progress
     */
    value: prop_types_1.default.number,
    /**
     * Define ProgressBar size
     */
    size: prop_types_1.default.oneOfType([
        prop_types_1.default.number,
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(types_1.progressBarSize)),
    ]),
    text: prop_types_1.default.string,
    /**
     * Tell when ProgressBar is stretched to width
     */
    fullWidth: prop_types_1.default.bool,
};
ProgressBar.defaultProps = {
    value: 0,
    size: types_1.progressBarSize.default,
    text: '',
    fullWidth: false,
};
exports.default = (0, oxygen_config_1.withTheme)(ProgressBar, themeName_1.THEME_NAME);
